<template>
  <div class="record">
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float" @submit.prevent>
        <div class="form-group">
          <label for>会员卡名称:</label>
          <el-select v-model.trim="search.rentMonthChargeId" clearable>
            <el-option
              v-for="rent in rentMonthList"
              :value="rent.id"
              :key="rent.id"
              :label="rent.name"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for="bdate">开始时间:</label>
          <el-date-picker
            clearable
            value-format="yyyy"
            v-model="search.beginDate"
            type="year"
          >
          </el-date-picker>
        </div>
        <div class="form-group">
          <label for="bdate">结束时间:</label>
          <el-date-picker
            clearable
            value-format="yyyy"
            v-model="search.endDate"
            type="year"
          >
          </el-date-picker>
        </div>

        <div class="form-group others">
          <span class="search_btn">
            <el-button
             size="small"
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
            >
              查询
            </el-button>
          </span>
          <span class="download_btn">
            <el-button
              type="primary"
              size="small"
              @click="onDownloadClick"
              :loading="downLoading"
              >导出EXCEL</el-button
            >
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          show-overflow-tooltip
          label="统计时间"
          prop="chargeDate"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="会员卡名称"
          prop="chargeName"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="金额" prop="totalRealPay">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="购买数量" prop="crtNum">
        </el-table-column>
      </el-table>
    </div>

    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { rentMonthPage } from "@/api/url";
import Page from "@/page/commons/page";
import dayjs from "dayjs";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        beginDate: "",
        endDate: "",
        rentMonthChargeId: "",
      },
      tableListData: [],
      pageObj: {},
      totalMap: {},
      loading: false,
      downLoading: false,
      rentMonthList: [],
    };
  },
  components: {
    Page,
  },
  computed: {},

  created: function() {},
  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getRentMonth();
  },

  watch: {},
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      const { beginDate, endDate, rentMonthChargeId, pageSize } = this.search;
      let params = {
        limit: pageSize,
        page: curPage,
      };
      if (rentMonthChargeId) {
        params = {
          ...params,
          rentMonthChargeId,
        };
      }

      if (beginDate) {
        params = {
          ...params,
          beginTime: beginDate,
        };
      }

      if (endDate) {
        params = {
          ...params,
          endTime: endDate,
        };
      }

      this.$get("/api/parking/rentMonthOrder/yearStatement", {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          _this.tableListData = data.data.rows || [];
          _this.totalMap = data.data.totalMap ?? {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      var flTime = this.timeCompare(this.search.beginDate, this.search.endDate);
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.beginDate) &&
        Boolean(this.search.endDate)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.beginDate) &&
        !Boolean(this.search.endDate)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function(bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getFullYear();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getFullYear();
      if (bdate - edate >= 0) {
        return true;
      } else {
        return false;
      }
    },
    async onDownloadClick() {
      const { beginDate, endDate, rentMonthChargeId } = this.search;
      let params = {};
      if (rentMonthChargeId) {
        params = {
          ...params,
          rentMonthChargeId,
        };
      }
      if (beginDate) {
        params = {
          ...params,
          beginTime: beginDate,
        };
      }
      if (endDate) {
        params = {
          ...params,
          endTime: endDate,
        };
      }
      try {
        this.downLoading = true;
        await this.$downloadFileRequest(
          "/api/parking/rentMonthOrder/yearReportExport",
          { ...params },
          "月年租卡年报"
        );
      } catch (e) {
        console.error(e);
        this.$layer.msg("导出失败，请稍后再试", { time: 1 });
      } finally {
        this.downLoading = false;
      }
    },
    getSummaries(param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
        }
        if (index === 2) {
          sums[index] = this.totalMap?.totalRealPay ?? 0;
        }
        if (index === 3) {
          sums[index] = this.totalMap?.totalCrtNum ?? 0;
        }
      });
      return sums;
    },
    getRentMonth() {
      this.$get(rentMonthPage(), {
        limit: 100,
        page: 1,
      })
        .then((data) => {
          if (data.status != 200) return;
          this.rentMonthList = data?.data?.rows ?? [];
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  padding: 10px 10px 0 10px;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
.gap {
  margin-right: 5px;
}
</style>
<style>
.record .el-date-editor {
  width: auto;
}
.record .el-date-editor.el-input__inner {
  max-width: none;
}
.record .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.record .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.record .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.record .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.record .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.record .searchbox .el-select {
  width: 150px !important;
}

.record .order_searchbox .form-control {
  width: 150px;
}
.record .order_searchbox form {
  height: auto;
}

.record .el-dialog {
  margin-top: 10vh !important;
}

.record .el-icon-arrow-down {
  font-size: 12px;
}

.record .dowload {
  padding-left: 10px;
  display: inline-block;
}

.record .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.record img {
  overflow: hidden;
}

.record .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.record .searchbox .form-inline {
  overflow: auto;
}
.record .is-gray {
  color: #666;
  cursor: not-allowed;
}
</style>
<style>
.record .list-right {
  height: calc(100vh - 250px) !important;
  padding-bottom: 0;
}

.record .el-table__footer-wrapper tbody td.el-table__cell {
  text-align: center;
  color: red;
}
</style>
